import type {
  ProfileStatsResponse,
  ProfileHistoryResponse,
  UpdateProfileRequest,
  UpdateProfileResponse,
} from '@codedrill/shared';
import { apiFetch } from './client';

export async function apiGetProfileStats(): Promise<ProfileStatsResponse> {
  return apiFetch<ProfileStatsResponse>('/profile/me');
}

export async function apiGetProfileHistory(
  page = 1,
  pageSize = 20,
): Promise<ProfileHistoryResponse> {
  return apiFetch<ProfileHistoryResponse>(
    `/profile/history?page=${page}&pageSize=${pageSize}`,
  );
}

export async function apiUpdateProfile(
  updates: UpdateProfileRequest,
): Promise<UpdateProfileResponse> {
  return apiFetch<UpdateProfileResponse>('/profile/me', {
    method: 'PATCH',
    body: JSON.stringify(updates),
  });
}
